import { createContext, useCallback, useContext, useMemo, useRef, useState } from 'react';

const OrderCorrectionDraftContext = createContext({
	hasPending: false,
	isSaving: false,
	setDraftStatus: () => {},
	registerSave: () => {},
	savePending: async () => {},
});

export const OrderCorrectionDraftProvider = ({ children }) => {
	const saveRef = useRef(null);
	const [status, setStatus] = useState({ hasPending: false, isSaving: false });

	const registerSave = useCallback((saveFn) => {
		saveRef.current = saveFn;
		return () => {
			if (saveRef.current === saveFn) saveRef.current = null;
		};
	}, []);

	const savePending = useCallback(async () => {
		if (typeof saveRef.current === 'function') return saveRef.current();
	}, []);

	const setDraftStatus = useCallback((next) => {
		setStatus((prev) => {
			const hasPending = Boolean(next?.hasPending);
			const isSaving = Boolean(next?.isSaving);
			if (prev.hasPending === hasPending && prev.isSaving === isSaving) return prev;
			return { hasPending, isSaving };
		});
	}, []);

	const value = useMemo(
		() => ({
			hasPending: status.hasPending,
			isSaving: status.isSaving,
			setDraftStatus,
			registerSave,
			savePending,
		}),
		[status.hasPending, status.isSaving, setDraftStatus, registerSave, savePending],
	);

	return <OrderCorrectionDraftContext.Provider value={value}>{children}</OrderCorrectionDraftContext.Provider>;
};

export const useOrderCorrectionDraft = () => useContext(OrderCorrectionDraftContext);
